import { render } from "./NewTransactionView.vue?vue&type=template&id=716ac43a"
import script from "./NewTransactionView.vue?vue&type=script&lang=js"
export * from "./NewTransactionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__